var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9981 12.9996V20.9996M11.9981 20.9996L7.99808 16.9996M11.9981 20.9996L15.9981 16.9996M4.39108 15.2686C3.57434 14.5541 2.9349 13.6595 2.52324 12.6555C2.11159 11.6515 1.939 10.5655 2.0191 9.48329C2.0992 8.40111 2.4298 7.35237 2.98479 6.41989C3.53978 5.48741 4.30396 4.69673 5.21699 4.11028C6.13001 3.52384 7.16688 3.15769 8.2457 3.04076C9.32453 2.92383 10.4158 3.05931 11.4332 3.43651C12.4507 3.81371 13.3666 4.4223 14.1085 5.21422C14.8503 6.00613 15.398 6.95968 15.7081 7.99957H17.4981C18.4701 7.99945 19.4161 8.31409 20.1944 8.89643C20.9728 9.47876 21.5416 10.2975 21.8159 11.23C22.0901 12.1626 22.055 13.1589 21.7158 14.0699C21.3765 14.9809 20.7515 15.7575 19.9341 16.2836",
    stroke: "#00286E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg20);
export default __webpack_public_path__ + "static/media/svg20.474b0f142ca40416f751b4908ad8a6b1.svg";
export { ForwardRef as ReactComponent };